import {
    GET_SHIPPED_SUMMARY_REQUEST,
    GET_SHIPPED_SUMMARY_SUCCESS,
    GET_SHIPPED_SUMMARY_ERROR,
  } from "../actions/types";
  
  export const getShippedSummaryReducer = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_SHIPPED_SUMMARY_REQUEST:
        return {
          loading: true,
        };
      case GET_SHIPPED_SUMMARY_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_SHIPPED_SUMMARY_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  